module.exports = __webpack_public_path__ + "static/img/wx.7c9a8f59.svg";